export class RouteTypes {
  static intraVenous = "intra-venous";
  static intraMuscular = "intra-muscular";
  static intraArticular = "intra-articular";
  static oral = "oral";
  static other = "other";
  static noTreatment = "no_treatment";
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/core/types/route-types.ts